export const setTotalPictures = (total) => ({
  type: "SET_TOTAL_PICTURES",
  payload: total,
});
